<ng-container [ngSwitch]="status">
    <label class="status bg large status-null" *ngSwitchCase="BLUECHAT_LOAD_STATUS.NULL">
        <span [i18n]="'bluechat.load-status.null'"></span>
    </label>
    <label class="status bg large status-open" *ngSwitchCase="BLUECHAT_LOAD_STATUS.OPEN">
        <span [i18n]="'bluechat.load-status.open'"></span>
    </label>
    <label class="status bg large status-planned" *ngSwitchCase="BLUECHAT_LOAD_STATUS.PLANNED">
        <span [i18n]="'bluechat.load-status.planned'"></span>
    </label>
    <label class="status bg large status-tendered" *ngSwitchCase="BLUECHAT_LOAD_STATUS.TENDERED">
        <span [i18n]="'bluechat.load-status.tendered'"></span>
    </label>
    <label class="status bg large status-tender-rejected" *ngSwitchCase="BLUECHAT_LOAD_STATUS.TENDER_REJECTED">
        <span [i18n]="'bluechat.load-status.tender_rejected'"></span>
    </label>
    <label class="status bg large status-tender-accepted" *ngSwitchCase="BLUECHAT_LOAD_STATUS.TENDER_ACCEPTED">
        <span [i18n]="'bluechat.load-status.tender_accepted'"></span>
    </label>
    <label class="status bg large status-loading-confirming" *ngSwitchCase="BLUECHAT_LOAD_STATUS.LOADING_CONFIRMING">
        <span [i18n]="'bluechat.load-status.loading_confirming'"></span>
    </label>
    <label class="status bg large status-loaded-confirmed" *ngSwitchCase="BLUECHAT_LOAD_STATUS.LOADED_CONFIRMED">
        <span [i18n]="'bluechat.load-status.loaded_confirmed'"></span>
    </label>
    <label class="status bg large status-in-transit" *ngSwitchCase="BLUECHAT_LOAD_STATUS.IN_TRANSIT">
        <span [i18n]="'bluechat.load-status.in_transit'"></span>
    </label>
    <label class="status bg large status-stopped" *ngSwitchCase="BLUECHAT_LOAD_STATUS.STOPPED">
        <span [i18n]="'bluechat.load-status.stopped'"></span>
    </label>
    <label class="status bg large status-completed" *ngSwitchCase="BLUECHAT_LOAD_STATUS.COMPLETED">
        <span [i18n]="'bluechat.load-status.completed'"></span>
    </label>
    <label class="status bg large status-closed" *ngSwitchCase="BLUECHAT_LOAD_STATUS.CLOSED">
        <span [i18n]="'bluechat.load-status.closed'"></span>
    </label>
    <label class="status bg large status-cancelled" *ngSwitchCase="BLUECHAT_LOAD_STATUS.CANCELLED">
        <span [i18n]="'bluechat.load-status.cancelled'"></span>
    </label>
</ng-container>
